import { useFetch2 } from "../../util";

type FindCompanyInput = {
  offset: number;
  limit: number;
  name?: string;
};

type CompanyListItem = {
  id: number;
  name: string;
  plataformName: string;
  active: boolean;
} & Record<string, unknown>;

type FindCompanyResponse = {
  result: CompanyListItem[];
  total: number;
};

type SearchCompanyResponse = {
  id: number;
  name: string;
  email: string;
  sendInvite: boolean;
  plataformName: string;
  active: boolean;
  workspaceQuota: number;
  userQuota: number;
  botQuota: number;
  allowCampaignCreation: boolean;
  whatsappQrcode?: boolean;
  whatsappApiMeta?: boolean;
  livechat?: boolean;
  facebook?: boolean;
  instagram?: boolean;
  pipeline?: boolean;
  calendar?: boolean;
};

type CompanyUpsertInput = {
  name: string;
  email: string;
  sendInvite: boolean;
  plataform: number;
  active: boolean;
  workspaceQuota: number;
  userQuota: number;
  botQuota: number;
  allowCampaignCreation: boolean;
  whatsappQrcode: boolean;
  whatsappApiMeta: boolean;
  livechat: boolean;
  facebook: boolean;
  instagram: boolean;
  pipeline: boolean;
  calendar: boolean;
};

export default () => {
  const fetch = useFetch2();

  return {
    findCompany: async (
      input: FindCompanyInput
    ): Promise<FindCompanyResponse> => {
      const paramRequest = new URLSearchParams(
        input.name
          ? {
              offset: `${input.offset}`,
              limit: `${input.limit}`,
              name: input.name
            }
          : {
              offset: `${input.offset}`,
              limit: `${input.limit}`
            }
      );

      const response = await fetch<FindCompanyResponse>(
        `/api/companies?${paramRequest}`,
        {
          method: "GET"
        }
      );

      return response;
    },
    findPlataforms: async (): Promise<{ id: number; name: string }[]> =>
      fetch("/api/plataforms", { method: "GET" }),
    updateCompany: async (id: number, data: CompanyUpsertInput) =>
      fetch(`api/companies/${id}`, { method: "PUT" }, data),
    createNewCompany: async (data: CompanyUpsertInput) =>
      fetch("api/companies", { method: "POST" }, data),
    searchCompany: async (id: number): Promise<SearchCompanyResponse> =>
      fetch<SearchCompanyResponse>(`/api/companies/${id}`, { method: "GET" })
  };
};
